/*
 * Inits the builder showcase about page
 */
define(
  'reviewsRedesignInitializer',[
    'GeoFiltering',
    'reviewsHandler',
    'sortByFilterHandler',
    'starFilterHandler',
    'areaFilterHandler',
    'paginationHandler',
    'pageSizeFilterHandler',
    'favoritesLoader',
    'longTextHandler',
    'galleryModalHandler',
    'askQuestionLoader',
  ],
  () => {
    'use strict';

    /**
     * Used to click the selected stars filter button on initial load
     */
    function clickSelectedStars() {
      if (!localStorage) {
        return;
      }

      const starSelected = localStorage.getItem('selectedStars');
      if (starSelected) {
        const element = document.querySelector(`[data-component="filter-by-star"][data-rate="${starSelected}"]`);
        if (element === null) {
          return;
        }
        element.click();

        // clear it so it only opens it once
        localStorage.removeItem('selectedStars');
      }
    }
    clickSelectedStars();
  }
);

